import React, {Component} from 'react';
import axios from "axios";
import {Spinner} from "react-bootstrap";
import {Alert, Button, Card, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {connect} from "react-redux";
import {Link} from "react-router-dom";

class VerifyResetPasswordComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            messageError: '',
            confirmPassword: '',
            password: '',
            strengPass: 0,
            btnDisable: false,
            errorForm: false,
            messageErrorForm: '',
            email: '',
            success: false,
            messageSucess: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if ( typeof this.props.token !== 'undefined') {
            this.verifyResetPassword(this.props.token);
        }
        else {
            this.redirectError({
                error: 1,
                message: 'Xác nhận đổi mật khẩu cho tài khoản thất bại'
            });
        }
    }

    verifyResetPassword = (token) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/verifyResetPassword', { token: token },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        email: ref.data.email,
                        error: false,
                        isLoading: false,
                        messageError: '',
                        success: true,
                        messageSucess: 'Xác nhận yêu cầu đặt lại mật khẩu thành công. Vui lòng nhập mật khẩu mới vào ô bên dưới',
                    })
                } else {
                    if ( ref.data.error > 8000 ) {
                        this.redirectError({
                            error: 1,
                            message: ref.data.message
                        });
                    }
                    else {
                        this.setState({
                            error: true,
                            isLoading: false,
                            messageError: ref.data.message,
                            success: false,
                            messageSucess: '',
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false,
                    error: true,
                    messageError: 'Truy vấn đến Server thất bại',
                    success: false,
                    messageSucess: '',
                })
            })
    }

    redirect = async (item) => {
        await this.props.updateSuccessNotiUser(item);
        await this.props.redirect();
    }

    redirectError = async (item) => {
        await this.props.updateErrorNotiUser(item);
        await this.props.redirect();
    }

    changePassword = (event) => {
        let name = event.target.name;
        let password = event.target.value;
        let strengPass = this.passwordChanged(password);
        this.setState({
            [name]: password,
            strengPass: strengPass
        });
    }

    //kiểm tra mật khẩu
    passwordChanged = (pass) => {
        var  symbolSize = 0, natLog, score;
        var format = /[`!@#$%^&*()_+\-=\\[\]{};':",.<>?~]/;

        if ( pass.match(/[0-9]/) ) {
            symbolSize +=20;
        }
        if ( pass.match(/[a-z]/) ) {
            symbolSize +=28;
        }
        if ( pass.match(/[A-Z]/) ) {
            symbolSize +=28;
        }
        if ( format.test(pass) ) {
            symbolSize +=35;
        }
        if ( pass.match(/[^a-zA-Z0-9]/) ) {
            symbolSize +=35;
        }

        natLog = Math.log( Math.pow(symbolSize, pass.length) );
        score = natLog / Math.LN2;
        if (score > 100) {
            return 100;
        }
        return parseInt(score);
    }

    submitLogin = () => {
        // console.log( this.state.email + ' - ' + this.state.password + ' - ' + this.state.remember  );
        this.setState({
            btnDisable: true
        })
        let validate = this.validate();
        if ( validate ) {
            let item = {
                'email': this.state.email,
                'password': this.state.password,
                'confirmPassword': this.state.confirmPassword,
            };
            this.setState({
                isLoading: true
            });

            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };

            axios.post( process.env.REACT_APP_API_URL + '/api/confirmResetPassword', item,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            isLoading: false
                        });
                        // console.log(ref.data);
                        this.redirect( ref.data );
                    } else {
                        if ( ref.data.error > 8000 ) {
                            this.redirectError({
                                error: 1,
                                message: ref.data.message
                            });
                        }
                        else {
                            this.setState({
                                isLoading: false,
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                                btnDisable: false
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        errorForm: true,
                        messageErrorForm: 'Đổi mật khẩu cho tài khoản thất bại',
                        isLoading: false,
                        btnDisable: false
                    })
                })
        }
    }

    validate = () => {
        if ( this.state.password.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Mật khẩu không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.confirmPassword.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Nhập lại mật khẩu không được để trống',
                btnDisable: false
            })
            return false;
        }
        else if ( this.state.password !== this.state.confirmPassword ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Nhập lại mật khẩu không đúng',
                btnDisable: false
            })
            return false;
        }
        else if ( this.passwordChanged( this.state.password ) < 75 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Mật khẩu yếu. Mật khẩu phải có ký tự chữ số, chữ hoa, chữ thường và ký tự đặc biệt',
                btnDisable: false
            })
            return false;
        }
        return true;
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <Row
                            style={{
                                height: '100vh',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Col sm={10} md={9} lg={6} xl={5} className="m-3">
                                <Card body>
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                <div className='text-center'>
                                                    { this.state.messageError }
                                                </div>
                                            </Alert>
                                        ) : (
                                            <>
                                                <Form onSubmit={() => this.submitLogin()}>
                                                    <div className="text-center pb-4">
                                                        <img
                                                            src={ this.props.config.website_logo }
                                                            className="rounded"
                                                            style={{ width: 90, height: "auto", cursor: 'pointer' }}
                                                            alt="logo"
                                                        />
                                                        <h4 className="text-primary mt-2">{ this.props.config.website_company ? this.props.config.website_company : '' }</h4>
                                                    </div>
                                                    {
                                                        this.state.errorForm ? (

                                                            <Alert color="danger">
                                                                <div className='text-center'>
                                                                    { this.state.messageErrorForm }
                                                                </div>
                                                            </Alert>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                    {
                                                        this.state.success ? (

                                                            <Alert color="success">
                                                                <div className='text-center'>
                                                                    { this.state.messageSucess }
                                                                </div>
                                                            </Alert>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                    <FormGroup row className="mb-2">
                                                        <Col sm={6} className="mb-2">
                                                            <Label for={'Password'}>{'Mật khẩu'}</Label>
                                                            <Input type="password" className="form-control" placeholder="Password" name="password" onChange={this.changePassword} value={this.state.password} />
                                                            <div className="progress mt-1" id="passwordStrengthBar">
                                                                {
                                                                    this.state.strengPass > 75 ? (
                                                                        <div className="progress-bar progress-bar-success" role="progressbar"
                                                                             aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
                                                                             style={{ width: `${this.state.strengPass}%`}}
                                                                        >
                                                                            <span className="progress-text color-white text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            className="progress-bar progress-bar-danger" role="progressbar"
                                                                            aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
                                                                            style={{ width: `${this.state.strengPass}%`}}
                                                                        >
                                                                            <span className="progress-text color-black text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col sm={6} className="mb-2">
                                                            <Label for={'confirmPassword'}>{'Nhập lại mật khẩu'}</Label>
                                                            <Input type="password" className="form-control" placeholder="Nhập lại mật khẩu" name="confirmPassword" onChange={this.changeInput} value={this.state.confirmPassword} />
                                                        </Col>
                                                    </FormGroup>
                                                    <hr />
                                                    <Button
                                                        size="lg"
                                                        className="bg-gradient-theme-left border-0"
                                                        block
                                                        onClick={() => this.submitLogin()}
                                                        disabled={ this.state.btnDisable }
                                                    >
                                                        Đổi mật khẩu
                                                    </Button>
                                                </Form>
                                                <div className="text-center pt-1">
                                                    <h6>hoặc</h6>
                                                    <h6>
                                                        <Link to="/dang-nhap.html">Đăng nhập</Link>
                                                    </h6>
                                                </div>
                                            </>
                                        )
                                    }
                                </Card>
                            </Col>
                        </Row>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        config: state.configSystem.config,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VerifyResetPasswordComponent);